import DynamicPricing from "./DynamicPricing";

export default DynamicPricing;